import "@babel/polyfill";
import Vue from "vue";
import "./modules";
var VueCookie = require('vue-cookie');
// Tell Vue to use the plugin
 
import VueResource from "vue-resource";
import VueSweetalert2 from "vue-sweetalert2";
import router from "./router";
import store from "./store";
import i18n, { loadTranslations } from "./i18n";
import { pushInterceptor, initAuth } from "./auth";

import  'bootstrap';
import VueTyperPlugin from 'vue-typer';


import App from "./App.vue";
Vue.use(VueCookie);
Vue.use(VueResource);
Vue.use(VueSweetalert2);
Vue.use(VueTyperPlugin);

import VueRecaptchaPlugin from './recaptcha';
Vue.use(VueRecaptchaPlugin);

Vue.http.options.root = window.VUE_APP_API_URL;



// window.VUE_APP_RECAPTCHA_KEY = '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI';
// window.VUE_APP_RECAPTCHA_V3_KEY = '6LcrPn0pAAAAAEpH-CxV4rpcsfeTEqqAZM0rdhCv';

pushInterceptor(Vue.http, store, router);
loadTranslations();
initAuth(store) .then(() => {
    new Vue({
        store,
        router,
        render: h => h(App)
    });
    if(!router.history.current.name === 'unsubscribe'){
        router.push('dashboard');    
    } 

  }).finally(() => {
    new Vue({
        store,
        router,
        i18n,        
        render: h => h(App)
    }).$mount("#app");
});

store.dispatch("app/loader", true);

